<mat-card>
  <app-card-header [title]="blockData.title" [icon]="blockData.icon">
    <!-- <app-print-button class="d-phone-none" [tooltipText] = "blockData.printTooltipText" (printClick)="printBtnClick()" /> TODO -->
    <!--<app-share-button *ngIf="showShareBtn" (addToCalendarClick)="addToCalendarClick($event)" />-->
  </app-card-header>

  <mat-card-content>
    <app-exams-calendar [permissionKeys]="blockData.permissionKeys"
      [studentCalendarFilters]="blockData.studentCalendarFilters"
      [notificationsHeaderText]="blockData.lessonsNotificationsPopupHeaderText"
      (serverErrorAppeared)="serverErrorAppeared()" />
  </mat-card-content>
</mat-card>